<template>
  <div class="overlay">
    <spinner />
  </div>
</template>

<script>
import Spinner from "../components/Spinner";
export default {
  components: { Spinner }
};
</script>

<style lang="scss" scoped>
.overlay {
  z-index: 99;
  position: fixed;
  // margin: 5% auto;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.7);
  color: white;
  // border-radius: 15px;
  font-size: 20pt;
  backdrop-filter: blur(10px);
}
</style>